<template>
  <div class="PaB-product__detail">
    <div class="PaB-product-detail__header"
      v-if="!product.product_image.is_default && widgetOptions.style.product_images">
      <div class="PaB-product__image">
        <lazy-image :src="product.product_image.lg" :alt="product.name" :title="product.name" />
      </div>
      <div class="PaB-product-detail__vendor">
        <lazy-image v-if="useBrandLogo" :src="product.brand_logo.md" :alt="product.brand" :title="product.brand" />
        <span v-if="product.brand_logo.is_default && this.widgetOptions.style.display_brands">{{ product.brand }}</span>
      </div>
    </div>

    <div class="PaB-product__content">
      <div class="PaB-product__header">
        <h3 class="PaB-product__title" v-if="orderable">{{ selected.name }}</h3>
        <h3 class="PaB-product__title" v-else>{{ product.name }}</h3>
        <product-meta :useBrandText="useBrandText" :product="product" />
      </div>

      <div class="PaB-product__body">
        <div v-if="product.description" class="PaB-product__information">
          <h4 class="PaB-product__detail-title">Product Details</h4>
          <p class="PaB-product__description">{{ product.description }}</p>
        </div>

        <div class="PaB-product__add-to-order">
          <h4 class="PaB-product__price" v-if="orderable">
            <pretty-money :amt="selected.price_cents | currency({cents: true, whole_dollars: true})" :decimal="true" />
          </h4>
          <product-prices :product="product" v-else></product-prices>

          <div class="PaB-product__selection" v-if="orderable">
            <div class="PaB-product-variations" v-if="product.prices.length > 1">
              <select v-model="selected">
                <option v-for="price in product.prices" :key="price.id" :value="price">
                  {{ +price.unit }} {{ singularizeWeight(price.unit_type, price.unit) }}
                </option>
              </select>
              <icon-base>
                <icon-angle-down />
              </icon-base>
            </div>

            <quantity v-model="quantity" :max="available()" :value="quantity" />
          </div>
        </div>
      </div>

      <div class="PaB-product__footer" v-if="orderable">
        <app-button type="primary" :label="addedToCart ? 'Added to cart' : 'Add to cart'" @click.native="addToCart"
          v-if="available() > 0">
          <template slot="before">
            <transition name="PaB-added-to-cart">
              <icon-base width="1em" height="1em" v-if="addedToCart">
                <icon-checked-circle />
              </icon-base>
            </transition>
          </template>
        </app-button>
        <div v-else>
          Out-Of-Stock
        </div>
        <app-button type="secondary" label="View my cart" v-if="cartItems.length > 0" @click.native="viewCart">
        </app-button>
        <div class="flex-shim" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductMeta from '@/components/product/ProductMeta'
import Quantity from '@/components/Quantity'
import AppButton from '@/components/AppButton'
import ProductPrices from '@/components/product/ProductPrices'
import IconBase from '@/components/IconBase'
import IconAngleDown from '@/components/icons/IconAngleDown'
import IconCheckedCircle from '@/components/icons/IconCheckedCircle'
import LazyImage from '@/components/LazyImage'

export default {
  props: {
    product: {
      type: Object
    },
    orderable: {
      type: Boolean,
      default: false
    },
    useBrandText: {
      type: Boolean,
      default: false
    },
    useBrandLogo: {
      type: Boolean,
      default: false
    },
    initialPriceIndex: Number
  },
  components: {
    ProductMeta,
    Quantity,
    AppButton,
    ProductPrices,
    IconBase,
    IconAngleDown,
    IconCheckedCircle,
    LazyImage
  },
  data () {
    return {
      selected: this.product.prices[this.initialPriceIndex],
      quantity: 1,
      addedToCart: false
    }
  },
  created () {
    const product = {
      'id': this.selected.id,
      'name': this.selected.name,
      'brand': this.product.brand,
      'category': this.product.category,
      'price': this.selected.price_cents
    }
    this.eventTracking.viewProduct(product)
  },
  computed: {
    cartItems () {
      return this.$store.state.cart.order_items_attributes
    }
  },
  methods: {
    addToCart () {
      this.addedToCart = false
      this.$store.dispatch('cart/addItemToCart', {
        product: { ...this.product },
        item: { ...this.selected },
        quantity: this.quantity
      })
      this.$nextTick(() => {
        this.addedToCart = true
      })
    },
    viewCart () {
      const currentRoute = this.$router.currentRoute.fullPath
      this.$parent.$emit('close')

      this.$router.push(`${currentRoute}/cart`)
    },
    available () {
      return parseInt(this.selected['quantity_on_hand'])
    },
    singularizeWeight (unittype, amt) {
      if (amt <= 1.0 && amt > 0.0) {
        return unittype.slice(0, -1)
      } else {
        return unittype
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.PaB-product__content {
  border: 1px solid rgba(#7f7f7f, 0.4);
  .PaB-product__title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .PaB-product__detail-title {
    font-size: 16px;
    font-weight: bold;
  }
}
.PaB-product__body,
.PaB-product__header,
.PaB-product__footer {
  padding: 15px 25px;
}

.PaB-product-detail__vendor {
  position: absolute;
  margin: 10px;
  max-width: 85px;
  max-height: 100%;
  top: 0;
  right: 0;
  background-color: #fff;
  text-align: center;
  font-weight: bold;

  span {
    padding: 5px;
    display: block;
    color: #000;
  }

  img {
    display: block;
    width: 100%;
  }
}
.PaB-product-detail__header {
  // box-shadow: inset 0 0 140px rgba(#7f7f7f, 0.5);

  // background-image: radial-gradient(ellipse at center, #80c240 0%,#1f9f47 100%);
  // background-position: center center;
  // background-size: 100%;
}
.PaB-product__image {
  // position: relative;
  // height: 0;
  // padding-bottom: 400 / 714 * 100%;
  // overflow: hidden;
    display: flex;
    overflow: hidden;
    justify-content: center;
    padding: 20px;
  img {
    // position: absolute;
    // top: 50%;
    // left: 0;
    // transform: translateY(-50%);
    // width: 100%;
    height: 350px;
  }
}
.PaB-product__body {
  background-color: rgba(#7f7f7f, 0.1);
}
.PaB-product__description {
  line-height: 1.4em;
  margin: 16px 0 30px 0;
}
.PaB-product__footer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -7px;
  margin-right: -7px;
  > * {
    flex: 1 1 calc(50% - 14px);
    min-width: 200px;
    margin: 7px;
    text-transform: uppercase;
  }
}
.PaB-product__price {
  font-size: 34px;
  font-weight: 300;
  margin-bottom: 12px;
}
.PaB-product__selection {
  display: flex;
  flex-direction: row;
  max-width: 320px;
  justify-content: space-between;
  .PaB-product-variations {
    margin-right: 12px;
    flex: 1 1 200px;
    position: relative;
    select {
      background-image: none;
      display: block;
      width: 100%;
      appearance: none;
      min-height: 44px;
      height: 100%;
      border-radius: 0;
      line-height: 1;
      padding: 10px;
      margin: 0;
      background-color: #fff;
      font-size: inherit;
    }
    svg {
      position: absolute;
      top: 10px;
      right: 10px;
      pointer-events: none;
    }
  }
  .PaB-quantity {
    flex: 0 1 132px;
    width: 132px;
  }
  @media screen and (max-width: 380px) {
    display: block;
    .PaB-product-variations,
    .PaB-quantity {
      width: 100%;
      margin: 0;
      margin-bottom: 15px;
    }
  }
}

.PaB-added-to-cart-enter-active {
  transition: transform 0.2s cubic-bezier(0.17, 0.67, 0.5, 2);
}

.PaB-added-to-cart-enter,
.PaB-added-to-cart-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
